import PropTypes from 'prop-types';
import { DropdownSelect } from '@figure/frontlib-gui';
import { ID_TYPE } from 'shared/constants/identity';

const IDType = ({ values, touched, errors, setFieldValue, handleResetType }) => (
  <DropdownSelect
    data-test-id="type"
    id="type"
    label="ID type"
    name="type"
    value={values.type}
    errorText={touched.type && errors.type}
    required
    onChange={(e) => {
      const { value } = e.target;

      setFieldValue('type', value);
      handleResetType(value);
    }}
  >
    <option value="" disabled />
    {ID_TYPE.map((t) => (
      <option key={`${t.label}-${t.value}`} value={t.value}>
        {t.label}
      </option>
    ))}
  </DropdownSelect>
);

IDType.propTypes = {
  values: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired,
  touched: PropTypes.shape({
    type: PropTypes.bool,
  }).isRequired,
  errors: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  handleResetType: PropTypes.func.isRequired,
};

export default IDType;
